import React from "react";
import { Row, Col, Container } from 'react-bootstrap';

import "../../theme/index.css";

import Intro from '../../assets/2025/Intro.webp';
import FunRun from '../../assets/2026/5KFunRun.jpeg'
import Volunteer from '../../assets/CKYF_2022_Closing-11.webp'


export const RectangleImageText = () => {
    return (
        <Container fluid className="px-0">
            <Row className="my-auto g-0 cream-bkg">
                <Col lg={6} className="my-auto p-5">
                    <h2 className="py-4 text-center bluegray-text">A Day of Movement, Connection, and Community</h2>
                    <p>Join us for a full day of yoga, wellness, music, and meaningful connection at Casper Karma Yoga Fest—a heart-centered, donation-based event rooted in the spirit of Seva (selfless service).
                        <br /><br />
                        Set in Washington Park of Casper, this festival brings together local teachers, healers, artists, vendors, and community members to share practices that support the body, mind, and spirit. From energizing vinyasa flows and grounding yin classes to sound baths, meditation, kids yoga, and unique workshops—there’s something for everyone, no matter your experience level.
                        <br /><br />
                        Explore a vibrant collection of local vendors, enjoy nourishing food and drinks, experience live music, and don’t miss our Kids Market, where young entrepreneurs showcase their creativity and offerings.
                        <br /><br />
                        This festival is more than just a day of classes—it’s a space to reconnect, reset, and remember the power of community.
                        <br /><br />
                        🌱 Donation-based – give what you can, take what you need<br />
                        🌱 All proceeds support our Seva Project, helping provide free yoga and wellness offerings to the community<br />
                        <br /><br />
                        Come as you are. Bring your mat, your friends, and your open heart.
                        <br />
                        Let’s move, breathe, and grow—together.
                        <br /><br />
                        Suggested donation “ticket” prices of $5-$20. By Venmo now or in person.</p>
                    <Row className="justify-content-center text-center mx-0">
                        <Col lg={6} classname="px-0">
                            <a href="https://venmo.com/u/Casperyogafest_SEVA" target="_blank" rel="noreferrer" >
                                <button>Donation Based Tickets</button>
                            </a>
                        </Col>
                    </Row>
                </Col>
                <Col lg={6} className="px-0">
                    <img src={Intro} className="rectangle-image" alt="two people with one hand on heart and the other touching the other person's hand" />
                </Col>
            </Row>
            <Row className="my-auto g-0 white-bkg">
                <Col lg={6} className="px-0">
                    <img src={FunRun} className="funRun-rectablge-image" alt="A Pathway to Peace, a 5k Fun Run" />
                </Col>
                <Col lg={6} className="my-auto p-5">
                    <h2 className="py-4 text-center bluegray-text">A Pathway to Peace 5k Fun Run</h2>
                    <p>We decided to add a 5k fun run to the festival! This 5k will take you around Washington Park,
                        taking in the sights and sound of one of Casper's oldest parks. This race is meant to be fun
                        and relaxing. you can go for the gold or just take your time and take in the morning air.
                        All proceeds go towards funding the Casper Karma Yoga Festival and Sunday Seva, ensuring the
                        continuation of this donation/free yoga festival for the community for next year and many years to come! </p>
                    <ul>
                        <li>Check-in: 6:00am</li>
                        <li>Start: 6:15am</li>
                        <li>End: 7:30am</li>
                        <li>$10 (no t-shirt) | $25 (with t-shirt)</li>
                    </ul>
                    <Row className="justify-content-center text-center mx-0">
                        <Col md={6}>
                            <a href="hhttps://docs.google.com/forms/d/e/1FAIpQLSeopieoDK9ZVofpheqGqCRXqc4Q4bBnsc9VMjBUetLPJHI0bw/viewform?" target="_blank" rel="noreferrer" >
                                <button>5k Fun Run Registration</button>
                            </a>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="my-auto g-0 cream-bkg">
                <Col lg={6} className="my-auto p-5">
                    <h2 className="py-4 text-center bluegray-text">Why Is Casper Karma Yoga Fest Donation-Based? 🌱</h2>
                    <p>Yoga, meditation, movement, and healing practices have the power to transform lives, but cost can often be a barrier. By keeping our festival donation-based, we’re able to welcome people from all backgrounds and financial situations into this space of connection, growth, and community.</p>
                    <h4 className="mb-3">How can you help?</h4>
                    <ul>
                        <li>Attend the festival</li>
                        <li>Make a donation</li>
                        <li>Support our vendors and sponsors</li>
                        <li>Volunteer your time</li>
                        <li>Share our event with friends and family</li>
                        <li>Become a sponsor or community partner</li>
                    </ul>
                    <Row className="justify-content-center text-center mx-0">
                        <Col md={6} className="pt-3">
                            <a href="https://venmo.com/u/Casperyogafest_SEVA" target="_blank" rel="noreferrer" >
                                <button>Make a Donation</button>
                            </a>
                        </Col>
                        <Col md={6} className="pt-3">
                            <a href="https://docs.google.com/forms/u/3/d/1m5kwOd3jcQzbfVqI02J80iaAYtaREJpY3wpjHx68J4Y/edit?usp=drivesdk" target="_blank" rel="noreferrer">
                                <button>Volunteer your Time</button>
                            </a>
                        </Col>
                    </Row>
                </Col>
                <Col lg={6} className="px-0">
                    <img src={Volunteer} className="rectangle-image" alt="" />
                </Col>
            </Row>
        </Container>
    )
}